/* eslint-disable max-len */
/*
 * @Description: Description
 * @Author: Yongchao Wang
 * @Date: 2021-07-03 16:48:39
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-04-27 16:17:27
 */
import './App.css';
import { useEffect } from 'react';
import BasicRoute from './router';
import { storeLeadsInfo } from './utils/util';


function App() {
  storeLeadsInfo();
  useEffect(() => {
    if (!sessionStorage.getItem('initialHistoryLength')) {
      sessionStorage.setItem('initialHistoryLength', window.history.length);
    }
    if (process.env.REACT_APP_ENV === 'qa') {
      // eslint-disable-next-line global-require
      const VConsole = require('vconsole');
      // eslint-disable-next-line
      const vConsole = new VConsole();
    }
  }, []);

  return (
    <div className="App">
      <BasicRoute />
    </div>
  );
}

export default App;
